/**
 * Sanitizes decimal input by:
 * - Replacing commas with dots
 * - Removing invalid characters
 * - Stripping leading zeros
 * - Ensuring only a single decimal point exists
 *
 * @param rawValue Raw input string from the user
 * @returns Sanitized string ready to be set as input value
 */

export function sanitizeDecimalInput(
  rawValue: string,
  decimalSanitizerRoundingNumber?: number
): string {
  const roundingNumber = decimalSanitizerRoundingNumber ?? 2;
  let value = rawValue.replace(/,/g, "."); // Replace commas with dots
  value = value.replace(/[^\d.]/g, ""); // Remove non-numeric/non-dot characters

  if (value.startsWith(".") && value.length >= 2) {
    value = "0" + value;
  }

  value = value.replace(/^0+(\d)/, "$1"); // Remove leading zeros
  value = value.replace(/^(-?)0+(\d)/, "$1$2"); // Handle negative leading zero

  const parts = value.split(".");
  if (parts.length > 2) {
    value = parts[0] + "." + parts.slice(1).join(""); // Merge excess decimal parts
  }
  if (parts[1] === undefined) {
    return value;
  }
  value = `${parts[0]}.${parts[1].slice(0, roundingNumber)}`;

  return value;
}

export function toStartOfDayUTCTimestamp(timestamp: number): number {
  const SECONDS_IN_DAY = 24 * 60 * 60; // 86400

  return Math.floor(timestamp / SECONDS_IN_DAY) * SECONDS_IN_DAY;
}
